import { Vendor } from "@shared/types";

const setLabelPrintEnabledCustomerAccountNumbers = (labelPrintEnabledCustomerAccountNumbers: string | string[] | undefined) => {
  if (!labelPrintEnabledCustomerAccountNumbers) {
    return [];
  }
  const isStringValue = typeof labelPrintEnabledCustomerAccountNumbers === "string";
  if (!isStringValue) {
    return labelPrintEnabledCustomerAccountNumbers;
  }
  return JSON.parse(labelPrintEnabledCustomerAccountNumbers);
};

const getIsLabelPrintingEnabledForCustomerAccountNumbers = (
  labelPrintEnabledCustomerAccountNumbers: string | string[] | undefined,
  customerAccountNumber?: string
): boolean => {
  if (!customerAccountNumber || customerAccountNumber === "") {
    return true;
  }
  const customerAccountNumberArray = customerAccountNumber?.split(",");
  const accountNumberExists = customerAccountNumberArray?.some((number) => labelPrintEnabledCustomerAccountNumbers?.includes(`${number}`));
  return accountNumberExists;
};

export const isLabelPrintingEnabled = (vendor?: Vendor, customerAccountNumber?: string) => {
  if (!vendor) {
    return false;
  }
  const labelPrintEnabledCustomerAccountNumbers = setLabelPrintEnabledCustomerAccountNumbers(
    vendor.properties?.labelPrintEnabledCustomerAccountNumbers
  );
  if (!labelPrintEnabledCustomerAccountNumbers.length) {
    return false;
  }
  return getIsLabelPrintingEnabledForCustomerAccountNumbers(labelPrintEnabledCustomerAccountNumbers, customerAccountNumber);
};
